const TenQRevisionContent = `

Revision of an agreement.

10Q. (1) An agreement, subsequent to it having been entered into, may be revised by the Board, if,—

(a) there is a change in critical assumptions or failure to meet a condition subject to which the agreement has been entered into;

(b) there is a change in law that modifies any matter covered by the agreement but is not of the nature which renders the agreement to be non-binding ; or

(c) there is a request from competent authority in the other country requesting revision of agreement, in case of bilateral or multilateral agreement.

 

(2) An agreement may be revised by the Board either suo motu or on request of the assessee or the competent authority in India or the Director General of Income-tax (International Taxation).

(3) Except when the agreement is proposed to be revised on the request of the assessee, the agreement shall not be revised unless an opportunity of being heard has been provided to the assessee and the assessee is in agreement with the proposed revision.

(4) In case the assessee is not in agreement with the proposed revision the agreement may be cancelled in accordance with rule 10R.

(5) In case the Board is not in agreement with the request of the assessee for revision of the agreement, the Board shall reject the request in writing giving reason for such rejection.

(6) For the purpose of arriving at the agreement for the proposed revision, the procedure provided in rule 10L may be followed so far as they apply.

(7) The revised agreement shall include the date till which the original agreement is to apply and the date from which the revised agreement is to apply.




`;

export default TenQRevisionContent;